var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIconSvgDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1092_5403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5781 20.5H12.5781",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65433 35.0743C7.56644 35.3143 7.55426 35.5755 7.61942 35.8227C7.68458 36.0699 7.82396 36.2911 8.01876 36.4566C8.21356 36.6221 8.45442 36.724 8.70887 36.7483C8.96333 36.7727 9.21914 36.7185 9.44183 36.593L35.6918 21.579C35.8872 21.4709 36.0501 21.3124 36.1635 21.1201C36.2769 20.9277 36.3367 20.7085 36.3367 20.4852C36.3367 20.2619 36.2769 20.0427 36.1635 19.8504C36.0501 19.658 35.8872 19.4996 35.6918 19.3915L9.44183 4.4149C9.21981 4.29072 8.96519 4.23725 8.71198 4.2616C8.45876 4.28596 8.219 4.387 8.02473 4.55122C7.83045 4.71543 7.6909 4.93502 7.62472 5.18064C7.55853 5.42627 7.56886 5.68624 7.65433 5.92583L12.5778 20.4993L7.65433 35.0743Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1092_5403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.078125 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconSvgDark);
export default __webpack_public_path__ + "static/media/SendIconSVGDark.0d16d0ef96b01f485b1e2a13ab53737b.svg";
export { ForwardRef as ReactComponent };